import { Text } from "@sqymagma/elements"
import React from "react"
import { theme } from '../../utils/themeGet'

export const Paragraph = ({
  children,
  as = "span",
  color = "text01",
  textStyle = "bodyText",
  ...props
}) => {
  return (
    <Text
      color={color}
      textStyle={textStyle}
      as={as}
      css={`
        strong {font-weight: 600 }
      `}
      {...props}
    >
      {children}
    </Text>
  )
}



export const StrongGold = ({children}) => (
  <Text 
      as="strong"  
      className="strong-gold" 
      css={`&.strong-gold {color: ${theme("color.brand04")}}`}>
      {children}
  </Text>
  )
  


export const StrongWhite = ({children}) => (
  <Text 
      as="strong"  
      className="strong-white" 
      css={`&.strong-white {color: ${theme("color.text06")}}`}>
      {children}
  </Text>
)